'use client';
// TODO: Переписать на основе собственного шаблонизатора.
/**
 * Преобразует строку-шаблон применяя подстановки.
 *
 * @param template - входная строка;
 * @param substitutions - подстановки;
 * @param options - параметры шаблонизатора;
 * @param options.matcher - матчер паттерна подстановки;
 * @param options.purifier - матчер и подстановка для очистки пустых шаблонов подстановки
 * и выбора подстановки из substitution по имени;
 * @param options.finalizer - матчеры и подстановки для финальной очистки данных, например от двойных пробелов.
 * */ var compileTemplate = function(template, substitutions, options) {
    if (substitutions === void 0) substitutions = {};
    if (options === void 0) options = {
        matcher: /{{[\w-]+}}/gm,
        purifier: [
            /{{|}}/gm,
            ""
        ],
        finalizers: [
            [
                /  +/g,
                " "
            ]
        ]
    };
    var matcher = options.matcher, purifier = options.purifier;
    var result = template.replaceAll(matcher, function(token) {
        var matcher = purifier[0], replacer = purifier[1];
        var substitutionName = token.replaceAll(matcher, replacer);
        var substitution = substitutions[substitutionName];
        return substitution !== undefined ? String(substitution) : "";
    });
    [].concat([
        options.purifier
    ], options.finalizers).forEach(function(param) {
        var transform = param[0], substitution = param[1];
        result = result.replaceAll(transform, substitution);
    });
    return result;
};

export { compileTemplate };
